module.exports = __webpack_public_path__ + "static/media/attention.b6e8c3d6.svg";